module.exports = __webpack_public_path__ + "img/logo.c260bce4.svg";